import * as actionTypes from 'src/actions';

const initialState = { customSettings: [], customSettingsError: false };

const customSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CUSTOM_SETTINGS_SUCCESS: {
      return {
        ...state,
        customSettings: action.customSettings
      };
    }

    case actionTypes.EDIT_CUSTOM_SETTINGS_SUCCESS: {
      return {
        ...state,
        customSettings: [
          ...state.customSettings.filter((customSetting) => customSetting.id !== action.customSettings.id),
          action.customSettings
        ]
      };
    }

    case actionTypes.ADD_CUSTOM_SETTINGS_SUCCESS: {
      return {
        ...state,
        customSettings: [
          ...state.customSettings,
          {
            ...action.newCustomSettings
          }
        ]
      };
    }

    case actionTypes.CUSTOM_SETTINGS_ERROR: {
      return {
        ...state,
        customSettingsError: action.error
      };
    }

    default: {
      return state;
    }
  }
};

export default customSettingsReducer;